import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop",
  "use": "icon-stop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stop\"><defs><style type=\"text/css\"></style></defs><path d=\"M224 1024H96c-38.4 0-64-25.6-64-64V64C32 25.6 57.6 0 96 0h128c38.4 0 64 25.6 64 64v896c0 38.4-25.6 64-64 64z m704 0H800c-38.4 0-64-25.6-64-64V64c0-38.4 25.6-64 64-64h128c38.4 0 64 25.6 64 64v896c0 38.4-25.6 64-64 64z\" fill=\"#bebebe\" p-id=\"7423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol